import { motion } from 'framer-motion'
import { Shield, Database, Lock, Activity } from 'lucide-react'

const techFeatures = [
  {
    icon: Shield,
    title: 'Роли и права доступа',
    description: 'Гибкая система разграничения прав для разных сотрудников'
  },
  {
    icon: Database,
    title: 'Логирование и бэкапы',
    description: 'Регулярные бэкапы данных и полная история всех действий'
  },
  {
    icon: Lock,
    title: 'Защита вебхуков',
    description: 'Шифрование данных и защита API от несанкционированного доступа'
  },
  {
    icon: Activity,
    title: 'Мониторинг и SLA',
    description: 'Отслеживание времени реакции и контроль качества обслуживания'
  }
]

export default function TechStackSection() {
  return (
    <section className="py-24 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">
            Техстек и безопасность
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Надёжная инфраструктура и прозрачный контроль всех процессов
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {techFeatures.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-gray-800 rounded-2xl p-6 hover:bg-gray-750 transition-colors"
            >
              <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mb-4">
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold mb-2">{feature.title}</h3>
              <p className="text-gray-400 text-sm">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 text-center"
        >
          <p className="text-lg font-medium">
            Python • PHP • Docker • VPS • HTTPS • Laravel • Django
          </p>
        </motion.div>
      </div>
    </section>
  )
}
